<template lang="html">
<router-link :to="{ name: 'shop-item', params: { id: item.uid } }" class="shop-item">
	<div class="shop-item-image li flex jc-c">
		<img v-lazy="item.images[0].url" alt="item.title" />
	</div>
	<div class="li flex jc-c">
	<div class="sli lundi">
		{{ item.title }}
	</div>
	<div class="sli">
            <span v-if="isSoldOut(item.items)">{{ item.items[0].price }} CHF</span>
		<span v-else>Sold out</span>
	</div>
	</div>
</router-link>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			required: false
		}
	},
      methods: {
            isSoldOut(items) {
                  let soldout = false;
                  items.forEach(item => {
                       if(item.finite > 0) {
                              soldout = true;
                       }
                  });
                  return soldout;
            }
      }
};
</script>

<style lang="scss" scoped>
.shop-item {
	grid-column: span 1;
	.shop-item-image {
		height: 25vw;
		@media only screen and (max-width: 1024px) {
			height: 50vw;
		}
		img {
			width:100%;
			height:100%;
			object-fit: cover;
		}
	}
}
</style>
